module.exports = __webpack_public_path__ + "img/worldwide.31fc5540.webp";